/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import StepLabel from "@mui/material/StepLabel";

const StyledStepLabel = styled((props) => <StepLabel {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledStepLabel };
